export default __webpack_public_path__ + "static/media/screencaptureTogglTrack20210414141940.0cfe2dc7.png";